import { Database, FileSpreadsheet, Sigma, Table } from 'lucide-react';
import type { FeatureContent } from './types';

export const fogliCalcolo: FeatureContent = {
  slug: 'fogli-calcolo',
  navLabel: 'Fogli di calcolo',
  menuDescription:
    'Genera e modifica fogli di calcolo con formule e continua a lavorarci in Excel o ODS.',
  cardDescription:
    'Genera e modifica fogli di calcolo con formule e continua a lavorarci in Excel o ODS.',
  meta: {
    title: 'Fogli di calcolo con AI, con formule modificabili',
    description:
      'Descrivi il risultato che ti serve e Trovanorma costruisce un foglio di calcolo con dati, formule e struttura già impostati, da modificare ed esportare in Excel o ODS.',
  },
  hero: {
    title: 'Fogli di calcolo',
    subtitle:
      'Descrivi il risultato che ti serve e Trovanorma costruisce un foglio di calcolo con dati, formule e struttura già impostati. Lo modifichi direttamente e continui a lavorarci in Excel o ODS.',
  },
  statement: (
    <>
      Non una tabella da copiare
      <br />
      Un foglio su cui lavorare
    </>
  ),
  statementText:
    'Dai dati al calcolo, fino al file finale: Trovanorma trasforma la richiesta in un foglio modificabile, con formule che puoi verificare e continuare a utilizzare.',
  blocks: [
    {
      icon: Table,
      kicker: 'Fogli generati',
      title: 'Parti dal risultato che vuoi ottenere',
      description:
        'Descrivi il calcolo, il prospetto o la struttura che ti serve e Trovanorma genera un foglio di calcolo organizzato, pronto per essere completato e adattato.',
    },
    {
      icon: Sigma,
      kicker: 'Formule modificabili',
      title: 'I calcoli restano dentro il foglio',
      description:
        'Non solo valori finali: celle, formule e formattazione restano modificabili, così puoi aggiornare il foglio quando cambiano dati o ipotesi.',
    },
    {
      icon: Database,
      kicker: 'Dati e allegati',
      title: 'Parti anche dai dati che hai già',
      description:
        'Usa informazioni e documenti della conversazione come base per costruire il foglio, senza dover riportare manualmente ogni dato.',
    },
    {
      icon: FileSpreadsheet,
      kicker: 'Excel e ODS',
      title: 'Finisci il lavoro dove preferisci',
      description:
        'Scarica il foglio in formato Excel (.xlsx) o ODS e continua a modificarlo con gli strumenti che utilizzi già ogni giorno.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Descrivi cosa ti serve',
      description: 'Indica dati, variabili, calcoli e struttura del foglio che vuoi ottenere.',
    },
    {
      step: 2,
      title: 'Trovanorma costruisce il foglio',
      description: 'Organizza celle, contenuti e formule in un foglio di calcolo già utilizzabile.',
    },
    {
      step: 3,
      title: 'Modifica ed esporta',
      description:
        'Intervieni direttamente su dati, formule e formattazione oppure scarica il file in Excel o ODS per continuare a lavorarci.',
    },
  ],
  relatedSolutions: ['commercialisti', 'consulenti-del-lavoro', 'aziende'],
  closing: {
    title: 'Non partire da zero per il prossimo foglio di calcolo',
    text: 'Descrivi il risultato che vuoi ottenere e prova a trasformarlo in un foglio con formule modificabili, pronto da continuare in Excel o ODS.',
  },
};
